class FilterUtilities {
    static sortOrgByName (a, b) {
        if (a.Name > b.Name) {
            return 1;
        }
        if (a.Name < b.Name) {
            return -1;
        }
        return 0;
    }

    static sortProductByName (a, b) {
        if (a.ProductName > b.ProductName) {
            return 1;
        }
        if (a.ProductName < b.ProductName) {
            return -1;
        }
        return 0;
    }
}

export default FilterUtilities;
